export const EVENT_SET = "EVENT::SET"
export const EVENT_LOADING = "EVENT::LOADING"
export const EVENT_UPDATE = "EVENT::UPDATE"
